/**
 * Layout loader component
 * 
 */

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class Loader extends PureComponent {

	static propTypes = {
		
		children: PropTypes.node,
	}

	render() {
		
		const { children } = this.props;

		return (
			
	        <div className="layout-loader">
				{children}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/containers/layout/loader/loader.js